import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

export const useQuoteVariants = (quoteId?: number) => {
  const [quoteVariants, setQuoteVariants] = useState<TrpcOutputs['getQuoteVariantsByQuoteId']>([]);
  const { data: initialData, isLoading, error } = trpc.getQuoteVariantsByQuoteId.useQuery({ quoteId });

  useEffect(() => {
    if (initialData) setQuoteVariants(initialData);
  }, [initialData]);

  trpc.onQuoteVariantCreated.useSubscription(
    { quoteId },
    {
      onData: (newData: any) => {
        setQuoteVariants((prevData: any) => [...prevData, newData]);
      },
      onError: (err: any) => console.log('onQuoteVariantCreated error: ', err),
    },
  );

  trpc.onQuoteVariantUpdated.useSubscription(
    { quoteId },
    {
      onData: (newData: any) => {
        setQuoteVariants((prevData: any) => {
          return prevData.map((quoteVariant: any) => {
            if (quoteVariant.id === newData.id) return newData;
            return quoteVariant;
          });
        });
      },
      onError: (err: any) => console.log('onQuoteVariantUpdated error: ', err),
    },
  );

  trpc.onQuoteVariantDeleted.useSubscription(
    { quoteId },
    {
      onData: (deletedId: number) => {
        setQuoteVariants((prevData: any[]) => {
          const nextData = prevData.filter((quote) => quote.id !== deletedId);
          return nextData;
        });
      },
      onError: (err: any) => console.log('onQuoteVariantDeleted error: ', err),
    },
  );

  return [quoteVariants, isLoading, error?.message] as const;
};
